
import React from 'react';
import DiscriminationForm from '@/components/DiscriminationForm';
import { Toaster } from 'sonner';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

const Index = () => {
  return (
    <>
      <Toaster position="top-center" />
      <title>Workplace Discrimination Assessment Tool | LexAssess AI</title>
      <div className="max-w-full md:max-w-4xl mx-auto mt-2 mb-3 sm:mb-6 px-2 sm:px-5">
        <div className="text-center space-y-1 sm:space-y-3 mb-3 sm:mb-6">
          <h1 className="text-xl sm:text-3xl font-bold tracking-tight text-primary">Workplace Discrimination Assessment</h1>
          <p className="text-sm sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Document your workplace discrimination case with detailed timelines, key events, and supporting evidence.
          </p>
        </div>
        
        {/* Added prominent box with clear instructions */}
        <Alert className="bg-amber-50 border border-amber-200 mb-3 sm:mb-6 p-3 sm:p-4">
          <AlertCircle className="h-5 w-5 text-amber-600" />
          <AlertDescription>
            <div className="space-y-1 sm:space-y-2 text-amber-800">
              <p className="font-medium text-sm sm:text-base">Instructions for completing this form:</p>
              <ol className="list-decimal pl-4 sm:pl-5 space-y-1 sm:space-y-2 text-sm sm:text-base">
                <li>Start by entering your <strong>personal information</strong>.</li>
                <li>Select the <strong>protected characteristics</strong> relevant to your case.</li>
                <li>Choose and describe the <strong>type(s) of discrimination</strong> you experienced.</li>
                <li>Upload up to <strong>5 core supporting documents</strong> (max 5MB each).</li>
                <li><strong className="text-red-600 font-bold">You MUST add at least one key event with date and description</strong> for each discrimination type.</li>
                <li>Optionally add people involved and witnesses (highly recommended).</li>
                <li>You can upload <strong>additional evidence files</strong> for specific discrimination types later in the form.</li>
                <li>Review all information before submitting your assessment.</li>
              </ol>
            </div>
          </AlertDescription>
        </Alert>
      </div>
      <div className="w-full px-0 sm:px-0">
        <DiscriminationForm />
      </div>
    </>
  );
};

export default Index;
